/** Kunci audio Phaser — efek suara kontekstual */
export const AUDIO_KEYS = {
  AMBIENT: 'seism_ambient',
  UI_CLICK: 'sfx_ui_click',
  INTERACT: 'sfx_interact',
  COLLECT: 'sfx_collect',
  QUEST: 'sfx_quest',
  DIALOGUE: 'sfx_dialogue',
  DECISION: 'sfx_decision',
  ERROR: 'sfx_error',
  SCORE_UP: 'sfx_score_up',
  TRANSITION: 'sfx_transition',
  EARTHQUAKE: 'sfx_earthquake',
  EARTHQUAKE_RUMBLE: 'sfx_earthquake_rumble',
} as const;

export type SfxKey = Exclude<keyof typeof AUDIO_KEYS, 'AMBIENT' | 'EARTHQUAKE_RUMBLE'>;
